import * as actionTypes from '../actions';

const initialState = {
    productsData: [
        {
            key: "IP4",
            riskControl: {},
            retireeSpending: {},
            sp500: {},
            yir: {},
            efa: {},
            barclay: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        },
        {
            key: "IP5 MVA",
            riskControl: {},
            retireeSpending: {},
            sp500: {},
            yir: {},
            efa: {},
            barclay: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        },
        {
            key: "IP7",
            riskControl: {},
            retireeSpending: {},
            sp500: {},
            yir: {},
            efa: {},
            barclay: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        },
        {
            key: "IP5",
            riskControl: {},
            retireeSpending: {},
            sp500: {},
            yir: {},
            efa: {},
            barclay: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        }
    ],
    rilaData: [
        {
            key: "INDEX ACHIEVER",
            sp500Minus10PercentageOver250K: {},
            sp500OneYear50PercentageOver250K: {},
            sp500OneYear10PercentageOver250K: {},
            sp500SixYear10PercentageOver250K: {},
            eafeOneYear50PercenpageOver250K: {},
            eafeOneYear10PercenpageOver250K: {},
            realEstateOneYear50PercentageOver250K: {},
            realEstateOneYear10PercentageOver250K: {},
            spdrOneYear50PercentageOver250K: {},
            spdrOneYear10PercentageOver250K: {},
            sp500Minus10Percentage: {},
            sp500OneYear50Percentage: {},
            sp500OneYear10Percentage: {},
            sp500SixYear10Percentage: {},
            eafeOneYear50Percenpage: {},
            eafeOneYear10Percenpage: {},
            realEstateOneYear50Percentage: {},
            realEstateOneYear10Percentage: {},
            spdrOneYear50Percentage: {},
            spdrOneYear10Percentage: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        },
        {
            key: "INDEX ACHIEVER ADVISORY",
            sp500Minus10PercentageOver250K: {},
            sp500OneYear50PercentageOver250K: {},
            sp500OneYear10PercentageOver250K: {},
            sp500SixYear10PercentageOver250K: {},
            eafeOneYear50PercenpageOver250K: {},
            eafeOneYear10PercenpageOver250K: {},
            realEstateOneYear50PercentageOver250K: {},
            realEstateOneYear10PercentageOver250K: {},
            spdrOneYear50PercentageOver250K: {},
            spdrOneYear10PercentageOver250K: {},
            sp500Minus10Percentage: {},
            sp500OneYear50Percentage: {},
            sp500OneYear10Percentage: {},
            sp500SixYear10Percentage: {},
            eafeOneYear50Percenpage: {},
            eafeOneYear10Percenpage: {},
            realEstateOneYear50Percentage: {},
            realEstateOneYear10Percentage: {},
            spdrOneYear50Percentage: {},
            spdrOneYear10Percentage: {},
            userGroupGaig: false,
            userGroupRJ: false,
            userGroupWellsFargo: false,
            userGroupMmfa: false
        }
    ]
};

let getProducts = (state, data) => {
    let newState = Object.assign({}, state);
    newState = data;
    return newState;
};

const productReducer = (state = initialState, action) => {
    if (action.type === actionTypes.GET_PRODUCTS_CONFIGURATION) {
        return getProducts(state, action.data);
    }

    return state;
};

export default productReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/productReducer.js